import { useState, useEffect, useCallback } from 'react';
// Hook
export const useAsync = (asyncFunction, dependencies = [], immediate = true) => {
    const [status, setStatus] = useState('idle');
    const [value, setValue] = useState(undefined);
    const [error, setError] = useState(undefined);
    // The execute function wraps asyncFunction and
    // handles setting state for pending, value, and error.
    // useCallback ensures the below useEffect is not called
    // on every render, but only if asyncFunction changes.
    const execute = useCallback(() => {
        setStatus('pending');
        setValue(undefined);
        setError(undefined);
        return (asyncFunction()
            .then((response) => {
            setValue(response);
            setStatus('success');
        })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch((error) => {
            setError(error);
            setStatus('error');
        }));
    }, dependencies);
    // Call execute if we want to fire it right away.
    // Otherwise execute can be called later, such as
    // in an onClick handler.
    useEffect(() => {
        if (immediate) {
            execute();
        }
    }, [execute, immediate]);
    return { execute, status, value, error };
};
